import { useStorage } from "@vueuse/core";
import { resolveSupportedLocale } from "./locales";

const browserLanguage = typeof navigator === "undefined" ? null : navigator.language;

export const localeState = useStorage("language", resolveSupportedLocale(browserLanguage), localStorage);

export function updateLocale(newLocale: string): void {
  localeState.value = newLocale;
}
